import assignToThis from '../../helper/assignToThis';
import { ObjectOnly } from '@/classes/ObjectOnly';

export class LoadEnergyEfficiency {

  // replaces consumptionChangePercentage (saving are negative changes)
  public estimatedEnergySavings: number | null = null;

  //  public startDate: Date | null = null;

  public investmentCost: number | null = null;

  public constructor(obj: ObjectOnly = {}) {
    assignToThis(this, obj);

    //    this.startDate = this.startDate ? new Date(this.startDate) : null;
  }
}
